import React, { HTMLProps } from 'react';

import { FormControl, InputGroup } from 'react-bootstrap';

export default ({ type, ...restProps }: HTMLProps<HTMLInputElement>) => (
  <InputGroup>
    <FormControl
      className='form-control'
      type='number'
      step={0.01}
      min={0}
      lang='en'
      {...restProps}
    />
    <InputGroup.Addon>{type}</InputGroup.Addon>
  </InputGroup>
);
